import clsx from 'clsx'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
}

const AdminDataTableSection = ({ children, className }: Props) => {
  return (
    <section
      className={clsx(
        'mt-8 space-y-6 rounded-2xl border border-gray-200/90 bg-white/80 p-5 shadow-sm sm:p-6',
        className,
      )}
    >
      {children}
    </section>
  )
}

export default AdminDataTableSection
